var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        staticClass: "w-50",
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "4", sm: "8" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        label: "Sort",
                        "label-cols-sm": "3",
                        "label-align-sm": "right",
                        "label-size": "sm",
                        "label-for": "sortBySelect",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-select", {
                            staticClass: "w-75",
                            attrs: {
                              id: "sortBySelect",
                              options: _vm.sortOptions,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("-- none --"),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.sortBy,
                              callback: function ($$v) {
                                _vm.sortBy = $$v
                              },
                              expression: "sortBy",
                            },
                          }),
                          _c(
                            "b-form-select",
                            {
                              staticClass: "w-25",
                              attrs: { size: "sm", disabled: !_vm.sortBy },
                              model: {
                                value: _vm.sortDesc,
                                callback: function ($$v) {
                                  _vm.sortDesc = $$v
                                },
                                expression: "sortDesc",
                              },
                            },
                            [
                              _c("option", { domProps: { value: false } }, [
                                _vm._v("Asc"),
                              ]),
                              _c("option", { domProps: { value: true } }, [
                                _vm._v("Desc"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-0",
                      attrs: {
                        label: "Filter",
                        "label-cols-sm": "3",
                        "label-align-sm": "right",
                        "label-size": "sm",
                        "label-for": "filterInput",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "filterInput",
                              type: "search",
                              placeholder: "Type to Search",
                            },
                            model: {
                              value: _vm.filter,
                              callback: function ($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter",
                            },
                          }),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { disabled: !_vm.filter },
                                  on: {
                                    click: function ($event) {
                                      _vm.filter = ""
                                    },
                                  },
                                },
                                [_vm._v(" Clear ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      items: _vm.itemsEmp,
                      fields: _vm.fields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                      filter: _vm.filter,
                      "filter-included-fields": _vm.filterOn,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFiltered,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(startDate)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(data.item.startDate)) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(employeeId)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getEmployee(data.item.employeeId)) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(returnDate)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(data.item.returnDate)) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(managerId)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getEmployee(data.item.managerId)) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(leaveTypeID)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getLeaveType(data.item.leaveTypeID)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(approvedDate)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(data.item.approvedDate)) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(status)",
                        fn: function (data) {
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant: _vm.statusVariants[data.item.status],
                                },
                              },
                              [_vm._v(" " + _vm._s(data.item.status) + " ")]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "m-1",
                                attrs: {
                                  variant: "link",
                                  "toggle-class": "p-0",
                                  "no-caret": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button-content",
                                      fn: function () {
                                        return [
                                          _c("feather-icon", {
                                            staticClass:
                                              "align-middle text-body",
                                            attrs: {
                                              icon: "MoreVerticalIcon",
                                              size: "16",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      disabled: data.item.status !== "PENDING",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.approvalAction(
                                          "APPROVED",
                                          data.item.leaveRequestId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "CheckCircleIcon" },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "align-middle ml-50" },
                                      [_vm._v("Approved")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: {
                                      disabled: data.item.status !== "PENDING",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.approvalAction(
                                          "REJECTED",
                                          data.item.leaveRequestId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "XCircleIcon" },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "align-middle ml-50" },
                                      [_vm._v("Rejected")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
              _c("b-form-group", [
                _vm._v(
                  " Showing " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? _vm.perPage * (_vm.currentPage - 1) + 1
                        : 0
                    ) +
                    " to " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                        : 0
                    ) +
                    " of " +
                    _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                    " entries "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }